import service from '@/utils/server';

const modName='/toxin/toxinInspectVehicleManual/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/toxin/toxinInspectVehicleManual/api/index.js